"use client";

import { useMemo } from "react";

import { HomeDashboardTable } from "@/components/home-dashboard-table";
import { usePreloadDonor } from "@/hooks/useDonor";
import type { TopDonor } from "@/services/donors.service";

import { getHomeTopDonorsColumns } from "./homeTopDonorsColumns";

type Props = {
  topDonors: TopDonor[];
  isLoading: boolean;
};

export function HomeTopDonorsCard({ topDonors, isLoading }: Props) {
  const { preloadDonor } = usePreloadDonor();

  const columns = useMemo(
    () => getHomeTopDonorsColumns(preloadDonor),
    [preloadDonor],
  );

  return (
    <HomeDashboardTable
      title="Top donors"
      viewAllHref="/donors"
      columns={columns}
      data={topDonors}
      isLoading={isLoading}
      emptyMessage="No paid donations yet"
      getRowId={(row) => String(row.id)}
    />
  );
}
